import { useEffect, useState } from "react";
import { useAxios } from "../../axios/AxiosHelper";
import { useToast } from "../../hooks/ToastContext";

const useSetData = ({ initialParamsData = {} }) => {
  const { axios_helper_no_header } = useAxios();
  const toast = useToast();
  const [data, setData] = useState([]); /* COB Additional Detail Data */
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [paramsData, setParamsData] = useState(initialParamsData);
  const fetchData = async ({
    apiName,
    paramsData,
    apiMethod = "GET",
    reqPayload = null,
    getFetchDataCallback = null,
    noResponseCallback = null,
    otherQueryParams = {},
  }) => {
    const page = first / rows;
    try {
      const raw_response = await axios_helper_no_header(
        apiMethod,
        apiName,
        reqPayload,
        {
          page,
          size: rows,
          ...paramsData,
          ...otherQueryParams,
        },
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response?.length === 0) {
        setData([]);
        setTotalRecords(0);
        if (noResponseCallback !== null) {
          noResponseCallback(response);
        } else {
          toast.current.show({
            severity: "info",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000,
          });
        }
      } else {
        setData(response);
        setTotalRecords(pageResponse?.totalRecords);
        getFetchDataCallback?.(raw_response);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  const onPageChange = (event) => {
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };
  return {
    data,
    setData,
    first,
    setFirst,
    rows,
    setRows,
    totalRecords,
    setTotalRecords,
    currentPage,
    setCurrentPage,
    paramsData,
    setParamsData,
    fetchData,
    updateParamData,
    onPageChange,
  };
};

export default useSetData;
